import { route } from 'preact-router';

interface NavBarProps {
  currentPath: string;
}

const NAV_ITEMS = [
  { path: '/', icon: '📊', label: 'Dashboard' },
  { path: '/config', icon: '⚙️', label: 'Config' },
  { path: '/restart', icon: '🔄', label: 'Restart' },
  { path: '/workflows', icon: '⚡', label: 'Workflows' },
  { path: '/commands', icon: '🖥️', label: 'Commands' },
];

export function NavBar({ currentPath }: NavBarProps) {
  return (
    <nav class="nav-bar">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.path}
          class={`nav-item ${currentPath === item.path ? 'nav-item-active' : ''}`}
          onClick={() => {
            if (currentPath !== item.path) route(item.path);
          }}
          aria-label={item.label}
          aria-current={currentPath === item.path ? 'page' : undefined}
        >
          <span class="nav-icon">{item.icon}</span>
          <span class="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
